import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContractType } from '../../../shared/models/contract/contract-type.model';
import { CommonService } from '../../../shared/service/common.service';
import { ValidationUiService } from '../../../shared/service/ui/validation-ui';

@Component({
  selector: 'app-primary-insured-dob',
  templateUrl: './primary-insured-dob.component.html'
})
export class PrimaryInsuredDobComponent implements OnInit {
  @Output() submitAnswer: EventEmitter<string> = new EventEmitter<string>();
  @Output() underageWarning: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() contractType: ContractType;
  @Input() questionError: string;

  DOB = '';

  constructor(
    public validationUiService: ValidationUiService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    const initialDate = this.contractType?.policyHolder?.personType?.[0]?.birthDate;
    this.DOB = this.commonService.customDateFormat(initialDate, 'dd/MM/yyyy') || '';
  }

  onSubmitAnswer(date: string): void {
    this.DOB = date;
    this.submitAnswer.emit(date);
  }
}
